export const DEFAULT_CANCELLATION_POLICY = 'moderate';

export const CANCELLATION_POLICY_KEYS = [
  'flexible',
  'moderate',
  'strict',
  'non_refundable',
];

export const normalizeCancellationPolicy = (value) => (
  CANCELLATION_POLICY_KEYS.includes(value) ? value : DEFAULT_CANCELLATION_POLICY
);
